/**
 * 해당 토크의 데이터 타입. 대사(talk) / 효과음(sound) / 이미지(image) / 동영상(movie) / 풀스크린 이미지(fullscreen_image) / 풀스크린 비디오(fullscreen_video), 이모티콘(emoticon)
 */
export enum TalkDataType {
  Talk = 'talk',
  Sound = 'sound',
  Bgm = 'bgm',
  Image = 'image',
  Movie = 'movie',
  FullscreenImage = 'fullscreen_image',
  FullscreenVideo = 'fullscreen_video',
  Emoticon = 'emoticon',
  TalkEffect = 'talk_effect',
  None = 'none',
}
